import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getUseProjectVariationLink = (
    backend: string,
    email: string,
    linkToken: string
) => {
    return fetch(
        `${getApiUrl()}project_variation_links/${backend}/${email}/${linkToken}`,
        {
            method: 'GET',
            headers: {}
        }
    );
};

export default getUseProjectVariationLink;
